var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeDojo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.48,55.54c-1.55-1.48-4-1.42-5.48.13-1.61,1.69-3.78,2.62-6.12,2.62h-1.57c-1.36-.04-8.01-.79-8.01-11.51v-10.3c3.04-.17,6.19-1.01,9.58-5.23,1.34-1.67,1.07-4.11-.6-5.44-1.67-1.34-4.1-1.07-5.44.6-1.88,2.34-2.63,2.37-5.68,2.37h-.24s-1.59-.09-2.76-1.26c-1.1-1.1-1.66-2.92-1.66-5.43v-3.6c0-2.87-2.33-5.2-5.2-5.2h-30.6c-2.87,0-5.2,2.33-5.2,5.2v3.6c0,5.89-3.24,6.64-4.57,6.69h-.09c-2.9,0-3.38-.03-5.94-2.65-1.5-1.53-3.95-1.56-5.48-.06-1.53,1.49-1.56,3.95-.06,5.48,3.75,3.84,6.29,4.73,9.33,4.93v10.31c0,10.75-6.68,11.48-7.97,11.51h-1.61c-2.33,0-4.51-.93-6.12-2.62-1.48-1.55-3.93-1.6-5.48-.13-1.55,1.48-1.61,3.93-.13,5.48,2.56,2.68,5.86,4.35,9.46,4.84v20.86h78.29v-20.86c3.6-.5,6.9-2.16,9.46-4.84,1.48-1.55,1.42-4-.13-5.48ZM30.44,36.52h39.11v6.38H30.44v-6.38ZM37.25,21.03h25.51v1.05c0,2.53.41,4.76,1.19,6.69h-27.9c.74-1.81,1.2-4.01,1.2-6.69v-1.05ZM30.2,50.64h39.6c.41,3.09,1.3,5.61,2.48,7.64H27.72c1.18-2.03,2.07-4.55,2.48-7.64ZM18.6,78.97v-12.94h62.8v12.94H18.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeDojo);
export default __webpack_public_path__ + "static/media/acae_dojo.25a1a893.svg";
export { ForwardRef as ReactComponent };